import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "tag", "variant", "tokens"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { withDesignTokens } from '@segment/matcha/useDesignTokens';
import * as views from './Heading.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
var BaseHeading = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? "p" : _ref$tag,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "pMedium" : _ref$variant,
      tokens = _ref.tokens,
      rest = _objectWithoutProperties(_ref, _excluded);

  return _jsx(views.Heading, _objectSpread(_objectSpread(_objectSpread({
    ref: ref,
    variant: variant,
    tag: tag
  }, rest), tokens), {}, {
    children: children
  }));
});
export var Heading = withDesignTokens(BaseHeading, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[500]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[400]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[60]
    };
  },
  cdpWeek2023: function cdpWeek2023(theme) {
    return {
      color: theme.palette.neutrals.white[100]
    };
  }
});